import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
const faqs = [{
  question: 'How do I receive the material after purchase?',
  answer: 'Immediately after checkout you receive an email with your download links. Everything is delivered digitally, so you can start reading and planning your next class within minutes.'
}, {
  question: 'Do I need teaching experience to use this?',
  answer: 'No. The system is written for newly certified teachers. Every sequence, script, and adaptation is explained step by step, so you can teach from it on day one.'
}, {
  question: "Is this only for brand-new teachers, or does it work if I've already taught a few classes?",
  answer: "It works for both. If you've already taught, use it as a ready-made library to stop rebuilding class plans and to sharpen your cueing and adaptations."
}, {
  question: 'Are the 5 bonuses included in the price?',
  answer: 'Yes. All five bonuses — valued at $128 — are included free with your purchase today at no extra cost.'
}, {
  question: 'What format are the volumes in?',
  answer: 'Every volume is a digital PDF, formatted to be both print-ready and comfortable to read on a tablet or phone.'
}, {
  question: 'Do I have to pay monthly?',
  answer: 'No. This is a one-time payment of $19 with lifetime access and free updates. There is no subscription.'
}, {
  question: "What if it's not right for me?",
  answer: "You have 7 days. If it doesn't help you feel more prepared, email us for a full refund — and you keep the material anyway."
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-16 sm:py-24" data-id="element-74" data-mp="ixuw0viepbqk">
      <div className="mx-auto max-w-3xl" data-id="element-75" data-mp="j0half3psria">
        <h2 className="text-center text-2xl font-extrabold tracking-tight text-teal sm:text-4xl" data-id="element-76" data-mp="n07ynb1uwtj4">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 space-y-3" data-id="element-77" data-mp="2poq2n2rywtff">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="overflow-hidden rounded-3xl border border-sage/25 bg-cream-card" data-id="element-78" data-mp="2fw2a4k80tbmi" data-mpi={index}>
                <h3 data-id="element-79" data-mp="38lhit3c7qsf9">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-teal" data-id="element-80" data-mp="38m12aohihove">
                    <span className="text-[15px] font-semibold text-teal sm:text-base" data-id="element-81" data-mp="1n620y96hlcdu">
                      {faq.question}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.2
                }} className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-sage-tint" data-id="element-82" data-mp="3uupqr0g6s4kb">
                      <PlusIcon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-83" data-mp="cfnjs2q77wln" />
                    </motion.span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-84" data-mp="hh4grn5kaywy">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-85" data-mp="mcjrw7c6qgpo">
                      <p className="px-6 pb-6 text-[15px] leading-relaxed text-ink-soft" data-id="element-86" data-mp="2x5mlhugnh9ft">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}